export const GET_MONTHLY_STOCK_DATA = 'GET_MONTHLY_STOCK_DATA'
export const GET_GET_MONTHLY_STOCK_DATA_SUCCESS = 'GET_GET_MONTHLY_STOCK_DATA_SUCCESS'
export const GET_MONTHLY_STOCK_DATA_FAIL = 'GET_MONTHLY_STOCK_DATA_FAIL'

export const SET_MONTHLY_STOCK_DATA = 'SET_MONTHLY_STOCK_DATA'
export const RESET_MONTHLY_STOCK_DATA = 'RESET_MONTHLY_STOCK_DATA'

export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL'